<template>
    <div v-if="is_data_fetched">
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                     style="min-height: 600px; background-image: url(img/theme/profile-cover.png); background-size: cover; background-position: center top;"> 
            <!-- Mask -->
            <span class="mask bg-gradient-success opacity-8"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">
                <div class="row">
                    <div class="col-lg-7 col-md-10">
                        <h1 class="display-2 text-white">Hello {{user.name}}</h1>
                        <p class="text-white mt-0 mb-5">This is your profile page. You can see change the information in you profile and make sure to click the update button.</p>
                        <a @click="isedit = true" class="btn btn-info">Edit profile</a>
                    </div>
                </div>
            </div>
        </base-header>

        <div  class="container-fluid mt--7">
            <div class="row">
                <div v-if="!isadmin" class="col-xl-4 order-xl-2 mb-5 mb-xl-0">

                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                        <img :src="this.user.imageFilePath" class="rounded-circle">
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                            <div class="d-flex justify-content-between">
                                <base-button size="sm" type="default" class="float-right" @click="loadImg" >Update Pic</base-button>
                                
                            </div>
                            <input style="visibility:hidden" type="file" accept="image/jpg, image/jpeg, image/png" @change="uploadImage" name="my_file" id="my-file">
                        </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                                        <div>
                                            <span class="heading">22</span>
                                            <span class="description">Products</span>
                                        </div>
                                        <div>
                                            <span class="heading">10</span>
                                            <span class="description">Orders</span>
                                        </div>
                                      
                                    </div>
                                </div>
                            </div>
                            <div  class="text-center">
                                <div class="h5 font-weight-300">
                                    <i class="ni location_pin mr-2"></i>Bucharest, Romania
                                </div>
                                <div class="h5 mt-4">
                                    <i class="ni business_briefcase-24 mr-2"></i>Solution Manager - Creative Tim Officer
                                </div>
                                <div>
                                    <i class="ni education_hat mr-2"></i>University of Computer Science
                                </div>
                                <hr class="my-4" />
                                <p>Ryan — the name taken by Melbourne-raised, Brooklyn-based Nick Murphy — writes, performs and records all of his own music.</p>
                                <a href="#">Show more</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div  :class="widthClass">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">My account</h3>
                                </div>
                                <div class="col-2 text-right">
                                    <a  @click="getR()" class="btn btn-sm btn-primary" v-if="isedit">update</a>
                                </div>
                                <div class="col-2 text-right">
                                    <a  @click="isedit = false" class="btn btn-sm btn-warning" v-if="isedit">cancel</a>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <h6 class="heading-small text-muted mb-4">User information</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Username"
                                                        placeholder="Username"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.name"
                                            />
                                            <small style="color: red" v-if="error && errors.name">{{ errors.name[0] }}</small>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Email address"
                                                        placeholder="jesse@example.com"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.email"
                                                        disabled = "true"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Role"
                                                        placeholder="Role"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.role"
                                                        disabled = "true"
                                            />
                                        </div>
                                        <div v-if="user.role == 'wholesaler' || user.role == 'retailer'" class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Shop Name"
                                                        placeholder="Shop Name"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.shop_name"
                                            />
                                            <small style="color: red" v-if="error && errors.shop_name">{{ errors.shop_name[0] }}</small>
                                        </div>
                                         <div v-if="user.role == 'rider'" class="col-lg-6">
                                            <base-input alternative=""
                                                        label="ID number"
                                                        placeholder="ID number"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.id_number"
                                            />
                                            <small style="color: red" v-if="error && errors.id_number">{{ errors.id_number[0] }}</small>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Password"
                                                        placeholder="password"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.password"
                                            />
                                            <small style="color: red" v-if="error && errors.password">{{ errors.password[0] }}</small>
                                        </div>
                                    </div>
                                    
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">Contact information</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <base-input alternative=""
                                                        label="Phone"
                                                        placeholder="First name"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.phone"
                                            />
                                            <small style="color: red" v-if="error && errors.phone">{{ errors.phone[0] }}</small>
                                        </div>
                                        <div v-if="isedit" class="col-md-12">
                                            <VueGooglePlaces
                                                    :api-key="key"
                                                    types="establishment"
                                                    country="ke"
                                                    @placechanged="onPlaceChanged"
                                                    @noresult="onNoResult">
                                                    <base-input alternative=""
                                                                label="Location"
                                                                placeholder="Location"
                                                                input-classes="form-control-alternative"
                                                                v-model="user.location_name"
                                                    />
                                                    <small style="color: red" v-if="error && errors.location_name">{{ errors.location_name[0] }}</small>
                                            </VueGooglePlaces>
                                        </div>
                                        <div v-if="!isedit" class="col-md-12">
                                            <base-input alternative=""
                                                        label="Town"
                                                        placeholder="Town"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.location_name"
                                                        disabled = "true"
                                            />
                                        </div>
                                    </div>
                                    <div v-if="!isedit" class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Country"
                                                        placeholder="Country"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.county"
                                                        disabled = "true"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Address"
                                                        placeholder="address"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.address"
                                                        disabled = "true"
                                            />
                                        </div>
                                    </div>
                                    <div v-if="user.role == 'rider'" class="row">
                                        <div v-if="isedit" class="col-md-12">
                                            <VueGooglePlaces
                                                    :api-key="key"
                                                    types="establishment"
                                                    country="ke"
                                                    @placechanged="operationArea"
                                                    @noresult="onNoResult">
                                                    <base-input alternative=""
                                                                label="Operation area"
                                                                placeholder="Operation area"
                                                                input-classes="form-control-alternative"
                                                                v-model="user.operation_area"
                                                    />
                                                    <small style="color: red" v-if="error && errors.operation_area">{{ errors.operation_area[0] }}</small>
                                            </VueGooglePlaces>
                                        </div>
                                        <div v-if="!isedit" class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Area of operation"
                                                        placeholder="Area of operation"
                                                        input-classes="form-control-alternative"
                                                        v-model="user.operation_area"
                                                        disabled = "true"
                                            />
                                        </div>
                                        <div v-if="user.role == 'rider'" class="col-lg-6">
                                        <label for="">Vehicle type</label>
                                            <select v-model="user.vehicle_type" class="form-control" style="width: 100%; background:
                                            #f4f4f4; ">
                                                <option value="" selected>Vehicle type</option>
                                                <option value="Bicycle">Bicycle</option>
                                                <option value="Motorcycle">Motorcycle</option>
                                                <option value="Tuk-tuk">Tuk-tuk</option>
                                                <option value="Pickup">Pickup</option>
                                                <option value="Van">Van</option>
                                            </select>
                                             <small style="color: red" v-if="error && errors.vehicle_type">{{ errors.vehicle_type[0] }}</small>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
        <div class="vld-parent">
            <loading :active.sync="isLoading"
                     :can-cancel="true"
                     :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>
<script>
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
  export default {
    name: 'user-profile',
    components: {
            Loading
        },
    data() {
      return {
          user:{    
                    id: '',
                    name: '',
                    email: '',
                    phone: '',
                    role: '',
                    county: '',
                    longitude: '',
                    latitude: '',
                    address: '',
                    Imagefile:'',
                    imageFilePath:'',
                    location_name: '',
                    operation_area: '',
                    password: '',
                    shop_name: '',
                    id_number: '',
                    vehicle_type: '',
                    location: '',
          },
          key: "AIzaSyD_q2KJ5vODTs1xOXxn6j8gjX5ZMr-2YzY",
        isadmin:true,
        widthClass:'',
        isedit: false,
          invalid:false,
          isLoading:false,
          fullPage: true,
          error:false,
          errors:[],
          is_data_fetched: false,

      }
    },
      methods:{
          loadImg(){
              $('#my-file').click();
          },
          uploadImage(e){
              var img = e.target.files[0];
              
              this.user.imageFilePath = URL.createObjectURL(img);
              var reader = new FileReader();
                reader.onloadend = () => {
                    this.user.Imagefile = reader.result;;
                }
                reader.readAsDataURL(img);
                this.isedit = true;
          },
          getR(){
              if(this.user.role == "wholesaler" || this.user.role == "retailer"){
                  this.update('/retailer/dashboard/user/');
              }else if(this.user.role == "admin"){
                  this.update('/admin/user/');
              }else{
                  this.update('/rider/dashboard/user/');
              }
          },
            onPlaceChanged(e) {
                this.user.county = e.administrative_area_level_1;
                this.user.longitude = e.longitude;
                this.user.latitude = e.latitude;
                this.user.address = e.formatted_address;
                this.user.location_name = e.name;
            },
            onNoResult() {

            },
            operationArea(e) {
                this.operation = e;
                this.user.operation_area = this.operation.formatted_address + "," + this.operation.name + "," +
                    this.operation.administrative_area_level_1;
            },
          update(path){
              this.isLoading = true;
              this.invalid = false;
              if(this.user.password == ""){
                  delete this.user.password;
              }
              
              
              this.axios.post(''+path+''+this.$auth.user().id ,this.user)
                  .then(() =>{
                      this.isLoading = false;
                      this.isedit = false;
                      delete this.user.password;
                      this.error = false;
                      this.$swal({
                          icon: 'success',
                          title: 'Success',
                          text: 'User details have been updated'
                      })
                  })
                  .catch((resp) =>{
                      this.errors =  resp.response.data.errors;
                      this.error = true;
                      this.invalid = true
                      this.isLoading = false;
                  })
          }

      },
    created(){
                this.user.name = this.$auth.user().name
                this.user.email =this.$auth.user().email
                this.user.phone = this.$auth.user().phone
                this.user.role = this.$auth.user().role
                this.user.county = this.$auth.user().county
                this.user.longitude = this.$auth.user().longitude
                this.user.latitude = this.$auth.user().latitude,
                this.user.address = this.$auth.user().address,
                this.user.location_name = this.$auth.user().location_name
                this.user.id = this.$auth.user().id;
 





               if(this.user.role == 'admin' || this.user.role == 'rider'){
                   this.isadmin = true
                   this.widthClass= "col-xl-12 order-xl-1"
               }else{
                   this.isadmin = false
                   this.widthClass = "col-xl-8 order-xl-1"
               }
               if(this.user.role == 'wholesaler' || this.user.role == 'retailer'){
                   this.axios.get('/retailer/dashboard/shop-details/' + this.user.id)
                    .then((resp)=>{
                        var data = resp.data[0];
                        this.user.shop_name = data.shop.shop_name;
                        this.user.imageFilePath = data.shop.filePath;
                    })
               }
               if(this.user.role == 'rider'){
                   this.axios.get('/rider/dashboard/rider-details/' + this.user.id)
                    .then((resp)=>{
                        if(resp.data[0].ride != null ){
                            let data = resp.data[0];
                            this.user.operation_area = data.ride.area_of_operation;
                            this.user.id_number = data.ride.id_no;
                            this.user.vehicle_type = data.ride.vehicle_type;
                        }
                        
                    })
               }
               
               this.is_data_fetched = true
  },

  }
</script>
<style></style>
